import React from "react";
import {ReactSession} from "react-client-session";
import $ from "jquery";
import {Helpers} from "../config/Helpers";

class Products extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',

            dataProduct: [],
            loadingProduct: true,
            productSearch: '',
            productLimit: 50,
            selectedProducts: {},
            vendorPrices: {}
        }
    }

    componentDidMount() {
        this.getProducts();
    }

    getProducts = () => {
        $(".loader-wrapper").css("display", "");
        Helpers.getProduct('', '', 'yes', '', '').then(res => {
            $(".loader-wrapper").css("display", "none");
            this.setState({
                dataProduct: (res) ? res : [],
                loadingProduct: false
            });
        });
    };

    getFilteredProducts = () => {
        const search = this.state.productSearch.trim().toUpperCase();

        if(!search){
            return this.state.dataProduct;
        }

        return this.state.dataProduct.filter((item) => {
            return ['KodeBarang', 'NamaBarang', 'JenisBarang', 'KategoriBarang', 'Produsen'].some((key) => {
                return ((item[key]) ? item[key] : '').toString().toUpperCase().includes(search);
            });
        });
    };

    handleProductSearch = (e) => {
        this.setState({
            productSearch: e.target.value,
            productLimit: 50
        });
    };

    handleVendorPrice = (kode, value) => {
        this.setState({
            vendorPrices: Object.assign({}, this.state.vendorPrices, { [kode]: value })
        });
    };

    toggleProduct = (kode) => {
        const selectedProducts = Object.assign({}, this.state.selectedProducts);

        if(selectedProducts[kode]){
            delete selectedProducts[kode];
        }else{
            selectedProducts[kode] = true;
        }

        this.setState({ selectedProducts });
    };

    render() {
        const filtered = this.getFilteredProducts();
        const visible = filtered.slice(0, this.state.productLimit);

        return (
            <>
                <section className="content-main">
                    <div className="content-header">
                        <div>
                            <h2 className="content-title card-title">Products List</h2>
                            <p>Find and manage vendor products here</p>
                        </div>
                    </div>
                    <div className="card mb-4">
                        <header className="card-header">
                            <div className="row align-items-center">
                                <div className="col-md-5">
                                    <input type="text" placeholder="Cari produk (nama, kode, jenis, produsen)" className="form-control"
                                           value={this.state.productSearch} onChange={this.handleProductSearch}/>
                                </div>
                                <div className="col-md-4 text-muted">
                                    {filtered.length} produk ditemukan, {Object.keys(this.state.selectedProducts).length} dipilih
                                </div>
                            </div>
                        </header>
                        <div className="card-body">
                            {
                                this.state.loadingProduct ? (
                                    <p>Memuat produk...</p>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>Produk</th>
                                                    <th>Unit</th>
                                                    <th>Harga Grosir</th>
                                                    <th style={{minWidth: '160px'}}>Harga Jual Vendor</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    visible.map((item) => (
                                                        <tr key={item.KodeBarang} style={{cursor: 'pointer'}} onClick={() => {this.toggleProduct(item.KodeBarang)}}>
                                                            <td style={{width: '40px'}}>
                                                                <input type="checkbox" className="form-check-input"
                                                                       checked={!!this.state.selectedProducts[item.KodeBarang]}
                                                                       onClick={e => e.stopPropagation()}
                                                                       onChange={() => {this.toggleProduct(item.KodeBarang)}}/>
                                                            </td>
                                                            <td style={{width: '60px'}}>
                                                                <img src={item.img_url} alt="" width="48" height="48" style={{objectFit: 'contain'}}/>
                                                            </td>
                                                            <td>
                                                                <strong>{item.NamaBarang}</strong>
                                                                <div className="text-muted" style={{fontSize: '12px'}}>
                                                                    {item.KodeBarang} · {item.JenisBarang}{item.Produsen ? ' · ' + item.Produsen : ''}
                                                                </div>
                                                            </td>
                                                            <td>{item.UnitBesar}</td>
                                                            <td style={{whiteSpace: 'nowrap'}}>Rp {item.HargaGrosirBesar}</td>
                                                            <td onClick={e => e.stopPropagation()}>
                                                                <input type="text" placeholder="Harga jual" className="form-control form-control-sm"
                                                                       value={this.state.vendorPrices[item.KodeBarang] || ''}
                                                                       onChange={e => this.handleVendorPrice(item.KodeBarang, e.target.value)}/>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                                {
                                                    filtered.length === 0 && (
                                                        <tr><td colSpan="6" className="text-center text-muted">Produk tidak ditemukan</td></tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }

                            {
                                filtered.length > visible.length && (
                                    <button type="button" className="btn btn-sm btn-outline-primary"
                                            onClick={() => {this.setState({productLimit: this.state.productLimit + 50})}}>
                                        Tampilkan lebih banyak ({filtered.length - visible.length} lagi)
                                    </button>
                                )
                            }
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default Products;
